import store from '../store'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [
  // SERVICES ---------------------------------------------------
  {
    path: '/',
    component: () => import('../views/dashboard')
  },
  // {
  //   path: '/services/:id',
  //   redirect: '/services/:id/overview'
  // },
  {
    path: '/services',
    alias: '/service',
    component: () => import('../views/services'),
    children: [
      {
        path: ':id',
        // redirect: ':id/overview'
        component: () => import('../views/services/layout'),
        children: [
          {
            path: '',
            redirect: 'overview'
          },
          {
            path: 'overview',
            component: () => import('../views/services/overview')
          },
          {
            path: 'tickets',
            component: () => import('../views/services/tickets')
          },
          {
            path: 'health',
            component: () => import('../views/services/health')
          },
          {
            path: 'location',
            component: () => import('../views/services/location')
          }
        ]
      }
    ]
  },

  // SUPPORT ---------------------------------------------------
  {
    path: '/support/new',
    alias: '/ticket/new',
    component: () => import('../views/support')
  },
  {
    path: '/support/:id?',
    alias: '/ticket/:id?',
    component: () => import('../views/support')
  },
  {
    path: '/support/:id/*',
    alias: '/ticket/:id/*',
    component: () => import('../views/support')
  },

  // QUOTES ---------------------------------------------------
  {
    path: '/quotes/:id?',
    alias: '/quote/:id?',
    component: () => import('../views/quotes')
  },

  // AUTH ---------------------------------------------------
  {
    path: '/login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/forgot',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/reset',
    component: () => import('../views/Login.vue')
  },

  // USER ---------------------------------------------------
  {
    path: '/profile',
    component: () => import('../views/profile')
  },

  // ACCOUNT ---------------------------------------------------
  {
    path: '/account',
    component: () => import('../views/account')
  },

  // BILLING ------------------------------------------------
  {
    path: '/billing',
    component: () => import('../views/billing'),
    children: [
      {
        path: '',
        redirect: 'payment'
      },
      {
        path: 'payment',
        component: () => import('../views/billing/payment')
      },
      {
        path: 'history',
        component: () => import('../views/billing/history')
      }
    ]
  },

  // Staff trying to peak system
  {
    path: '/not-yet',
    component: () => import('../views/NotReadyYet.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Redirect to login if not authenticated
const openPaths = ['/login', '/forgot', '/reset', '/not-yet']
router.beforeEach((to, from, next) => {
  let isOpenPath = openPaths.indexOf(to.path) >= 0
  if (isOpenPath) {
    next()
    return
  }
  if (store.getters.isAuthenticated && store.getters.isUserLoaded) {
    if (store.getters.isSuperAdmin || store.getters.isMasqueraded) {
      next()
      return
    }
  }
  next('/login')
})

export default router
